<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ded"> </p>
<p class="DED"><span class="ePub-BI">FOR MY SON ANDREW</span></p>
<p class="DED"><span class="ePub-BI">YOU. ARE. WOW.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?c5dcb046